import {$, HttpBody} from 'simpli-web-sdk'
import UploadDados from '@/model/resource/UploadDados'
import * as Helper from '@/helpers'
import {classToPlain} from 'class-transformer'

export async function importFileToS3(request: any, idTipoUpload: number) {
    const json = JSON.stringify(classToPlain(request))

    const filename = Helper.uid()
    const preSignedUrl = async () => await new HttpBody(String).GET(`/user/upload-url/import?fileName=${filename}.json`)
    const url = await $.await.run(preSignedUrl)

    await fetch(url.data as string, {
        method: 'PUT',
        mode: 'cors',
        credentials: 'omit',
        headers: {
            'content-type': 'application/octet-stream',
            'sec-fetch-mode': 'cors',
        },
        body: stringToArrayBuffer(json),
    })

    const upload = new UploadDados()
    upload.urlArquivo = url.data.split('?')[0]
    upload.idTipoUploadFk = idTipoUpload
    await upload.inserirNaFila()
}

const stringToArrayBuffer = (value: string) => {
    const encoder = new TextEncoder()
    return encoder.encode(value).buffer
}
